import { createStore } from 'redux'
import reducer from 'src/State-Management/Reducers/rootReducer'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

const PersistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(PersistConfig, reducer)
let store = createStore(persistedReducer)
// let persistor = persistStore(store)

export {store}
